export default __webpack_public_path__ + "static/media/tou3.3e60026f.png";